<template>
  <v-avatar
    v-if="user !== null"
    :size="size"
    :style="{'background-color': backgroundColor}"
  >
    <strong
      class="initials"
      :class="{
        shadow: !initialsOnly,
      }"
      style="margin-left: 1px;"
      :style="{
        color: fontColor,
        'font-size': fontSize,
      }"
    >{{ firstNameInitial + lastNameInitial || '?' }}</strong>
  </v-avatar>
</template>

<script>
export default {
  name: 'UserInitials',
  props: {
    user: {
      type: Object,
      required: true,
    },
    size: {
      type: Number,
      default: 40,
    },
    color: {
      type: [String, Object],
      default: null,
    },
    initialsOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fontSize() {
      return (this.size / 40.0) * 18 + 'px';
    },
    fontColor() {
      if (this.initialsOnly) {
        return this.color;
      }
      return 'white';
    },
    backgroundColor() {
      if (this.initialsOnly) {
        return 'transparent';
      }
      return this.color;
    },
    firstNameInitial() {
      const firstName = this.user.first_name.trim();
      if (!firstName) {
        return '';
      }
      return firstName[0];
    },
    lastNameInitial() {
      const lastName = this.user.last_name.trim();
      if (!lastName) {
        return '';
      }
      // Given sth. like 'von Münchhausen' return 'M', not 'v':
      const lastNameTokens = lastName.split(' ');
      const lastToken = lastNameTokens[lastNameTokens.length - 1];
      return lastToken[0];
    },
  },
};
</script>

<style scoped>
.initials {
  text-transform: uppercase;
}
.initials.shadow {
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.32);
}
</style>



// WEBPACK FOOTER //
// src/components/UserManagement/UserInitials.vue